module.exports = __webpack_public_path__ + "static/media/icon-checkmark-base.94d05c3a.svg";